import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils';
import { FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

interface Document {
  id: number;
  document_name?: string;
  file_name?: string;
  entity_name?: string;
  module_type?: string;
  status?: string;
}

interface RecentDocumentsProps {
  documents: Document[];
}

const COLORS: Record<string, string> = {
  HRIS: '#10b981',
  CREDIT: '#3b82f6',
  DEBTOR: '#f59e0b',
  LEGAL: '#8b5cf6',
  GENERAL: '#6b7280',
};

export default function RecentDocuments({ documents }: RecentDocumentsProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">Dokumen Terbaru</CardTitle>
          <Link to={createPageUrl('DocumentList')}>
            <Button variant="ghost" size="sm">
              Lihat Semua
            </Button>
          </Link>
        </div>
      </CardHeader>
      <CardContent>
        {documents.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <FileText className="w-12 h-12 mx-auto mb-3 text-gray-300" />
            <p>Belum ada dokumen</p>
          </div>
        ) : (
          <div className="space-y-3">
            {documents.map(doc => (
              <div
                key={doc.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center"
                    style={{
                      backgroundColor:
                        (COLORS[doc.module_type || 'GENERAL'] || COLORS.GENERAL) + '20',
                    }}
                  >
                    <FileText
                      className="w-5 h-5"
                      style={{ color: COLORS[doc.module_type || 'GENERAL'] || COLORS.GENERAL }}
                    />
                  </div>
                  <div>
                    <p className="font-medium text-sm">{doc.document_name || doc.file_name}</p>
                    <p className="text-xs text-gray-500">
                      {doc.entity_name} - {doc.module_type}
                    </p>
                  </div>
                </div>
                <Badge
                  variant="outline"
                  className={
                    doc.status === 'valid'
                      ? 'bg-green-50 text-green-700'
                      : doc.status === 'pending_validation'
                        ? 'bg-amber-50 text-amber-700'
                        : 'bg-gray-50 text-gray-700'
                  }
                >
                  {doc.status}
                </Badge>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
